<style type="text/css" scoped="z">
	/*.el-dropdown-menu.el-popper{ width: 50%!important;opacity: 0.95;box-sizing: border-box; margin: 0;padding: 0; left: 0!important;right: 0;margin: auto; border-radius: 0;padding: 20px 0;background-color: rgb(65, 81, 97);border: none;}*/
	/*.el-dropdown-menu.el-popper{ background-color: rgb(65, 81, 97);}*/
	/*.el-dropdown-menu__item{ float: left;width: 20%;color: #fff;text-align: center;margin-top: 20px;}*/
	
	ul{margin: 0;padding: 0;}
	.el-dropdown{ color: #fff;cursor: pointer;}
	.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{ background-color: rgb(65, 81, 97);}
	.classyBB{ flex: 1;display: flex;flex-direction: row;justify-content: space-around;}

	.el-dropdown-menu{ background-color:  rgb(65, 81, 97);border: none; }
	.el-dropdown-menu__item{color: #fff; }
</style>
<template>
	<div class="tempD">
		<!--<div class="headD">
			<div class="logo"></div>
			<div class="logo_1"></div>
			<div class="shuline"></div>
			<div class="websiteName">
				<img src="../../public/icon/004.png" />
			</div>
			<div class="uinfoD">
				<div class="uphoto">
					<img :src="userObj?userObj.headimg?imgAPI+userObj.headimg:require('../../public/icon/001.jpg'):require('../../public/icon/001.jpg')" />
				</div>

				<div class="unnam">
					<el-dropdown v-if="isLogin" trigger="click" @command="handleCommand">
						<span class="el-dropdown-link">
						    {{userObj.nickname}}<i class="el-icon-arrow-down el-icon--right"></i>
						  </span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="1">个人中心</el-dropdown-item>
							<el-dropdown-item command="3">修改密码</el-dropdown-item>
							<el-dropdown-item command="2">退出登录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<div class="loginAregister" v-if="!isLogin" @click="goLogin">登录 / 注册</div>
				</div>
			</div>

		</div>-->
		<!--<div class="zhanweiBox" style="height: 90px;"></div>-->

		<div class="head_1">
			<div class="websiteTit" style="position: relative;">
				<img src="../../public/icon/002.png" />
				<span class="shuBox" style="width: 1px; background-color:#fff;height: 40px; display: inline-block;position: absolute;top: 0;bottom: 0;margin: auto;"></span>
				<img src="../../public/icon/003.png" />
				<img class="wbame" src="../../public/icon/004.png" />
			</div>
			<div class="meunBox" style="flex: 1;margin-top: 22.5px;">
				<div class="meuenBox">
					<div class="classfyD">
						<div class="classfyD_item" :class="selectIndex===0?'active':''" @click="openClassfy(0)">首页</div>

						<div class="classfyD_item" :class="selectIndex===0?'active':''">
							<el-dropdown>
								<span class="el-dropdown-link">
								        	平台服务
								     	</span>
								<el-dropdown-menu slot="dropdown" style="margin-top:15px;margin-right:-15px;">
									<el-dropdown-item>
										<span @click="openClassfy(9,1)">设计诊断</span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(10,1)">品牌创新</span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(11,1)">市场机遇</span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(12,1)">设计众筹</span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(4,1)">设计众包 </span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(13,1)">小贷试产 </span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(14,1)">共享设备 </span>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>

						<!--<div class="classfyD_item" :class="selectIndex===1?'active':''">
							<el-dropdown class="zk_dropdown">
								<span class="el-dropdown-link">
						        	平台服务
						     	</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item>
										<span @click="openClassfy(9)">设计诊断</span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(10)">品牌创新</span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(11)">市场机遇</span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(12)">设计众筹</span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(4)">设计众包 </span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(13)">小贷试产 </span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(14)">共享设备 </span>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>-->
						<div class="classfyD_item" :class="selectIndex===2?'active':''">
							<el-dropdown class="zk_dropdown">
								<span class="el-dropdown-link">
						        	中心概况
						     	</span>
								<el-dropdown-menu slot="dropdown" style="margin-top:15px;margin-right:-15px;">
									<el-dropdown-item>
										<span @click="openClassfy(5,2)">新闻资讯 </span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(16,2)">关于我们 </span>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
						<div class="classfyD_item" :class="selectIndex===4?'active':''">
							<el-dropdown class="zk_dropdown">
								<span class="el-dropdown-link">
						        	平台资源
						     	</span>
								<el-dropdown-menu slot="dropdown" style="margin-top:15px;margin-right:-15px;">
									<el-dropdown-item>
										<span @click="openClassfy(1,3)">产业孵化 </span>
									</el-dropdown-item>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(18,3)">知识产权 </span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(19,3)">金融服务 </span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(20,3)">项目申报 </span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(21,3)">其他服务 </span>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
						<div class="classfyD_item" :class="selectIndex===5?'active':''">
							<el-dropdown class="zk_dropdown">
								<span class="el-dropdown-link">
						        	设计资源
						     	</span>
								<el-dropdown-menu slot="dropdown" style="margin-top:15px;margin-right:-15px;">
									<el-dropdown-item>
										<span @click="openClassfy('设计成果')">设计成果 </span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy('专家资源')">专家资源 </span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy('设计机构')">设计机构 </span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy('设计师')">设计师 </span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(27)">设计院校 </span>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
						<div class="classfyD_item" :class="selectIndex===3?'active':''">
							<el-dropdown class="zk_dropdown">
								<span class="el-dropdown-link">
						        	赛事展会
						     	</span>
								<el-dropdown-menu slot="dropdown" style="margin-top:15px;margin-right:-15px;">
									<el-dropdown-item>
										<span @click="openClassfy(3,5)">赛事展会 </span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(23,5)">业内资讯 </span>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
						<div class="classfyD_item" :class="selectIndex===6?'active':''">
							<el-dropdown class="zk_dropdown">
								<span class="el-dropdown-link">
						        	政策法规
						     	</span>
								<el-dropdown-menu slot="dropdown" style="margin-top:15px;margin-right:-15px;">
									<el-dropdown-item>
										<span @click="openClassfy(6,6)">本地政策 </span>
									</el-dropdown-item>
									<el-dropdown-item>
										<span @click="openClassfy(25,6)">国内政策 </span>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
					</div>
				</div>
			</div>
			<div class="userBox" style="width: 270px;position: relative;">
				<div class="uinfoD">
					<div class="uphoto">
						<img :src="userObj?userObj.headimg?imgAPI+userObj.headimg:require('../../public/icon/001.jpg'):require('../../public/icon/001.jpg')" />
					</div>

					<div class="unnam">
						<el-dropdown v-if="isLogin" trigger="click" @command="handleCommand">
							<span class="el-dropdown-link">
						    {{userObj.nickname}}<i class="el-icon-arrow-down el-icon--right"></i>
						  </span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="1">个人中心</el-dropdown-item>
								<el-dropdown-item command="3">修改密码</el-dropdown-item>
								<el-dropdown-item command="2">退出登录</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<div class="loginAregister" v-if="!isLogin" @click="goLogin">登录 / 注册</div>
					</div>
				</div>
			</div>
		</div>

		<!--<div class="classfyD">
			<div class="classfyD_item" :class="selectIndex===0?'active':''" @click="openClassfy(0)">首页</div>
			<div class="classfyD_item" :class="selectIndex===1?'active':''" @click="openClassfy(1)">概念孵化</div>
			<div class="classfyD_item" :class="selectIndex===2?'active':''" @click="openClassfy(2)">人才服务</div>
			<div class="classfyD_item" :class="selectIndex===3?'active':''" @click="openClassfy(3)">赛事展会</div>
			<div class="classfyD_item" :class="selectIndex===4?'active':''" @click="openClassfy(4)">设计众包</div>
			<div class="classfyD_item" :class="selectIndex===5?'active':''" @click="openClassfy(5)">新闻资讯</div>
			<div class="classfyD_item" :class="selectIndex===6?'active':''" @click="openClassfy(6)">政策法规</div>
		</div>-->
		<div class="content">

			<router-view name="homeRoter" v-if="isRouterAlive"> </router-view>
		</div>
		<div class="footerD" style="z-index: 1;">
			<div class="headD" style="background-color: rgb(62, 58, 57);">
				<div class="logo"></div>
				<div class="logo_1"></div>
				<div class="shuline"></div>
				<div class="websiteName">
					<img src="../../public/icon/004.png" />
				</div>
			</div>
			<div class="clickMenu">
				<div class="clickMenu_item">About</div>
				<div class="clickMenu_item">版权声明</div>
				<div class="clickMenu_item">建议反馈</div>
				<div class="clickMenu_item">联系我们</div>
			</div>
			<div class="banuqan">copyright &copy; 2020 www.1522znsj.com</div>
			<div class="beian">蜀ICP备20018984号</div>
		</div>

		<el-dialog title="" width="500px" :visible.sync="dlog_login" :show-close="false" class="myDlog">
			<dlog_login v-on:parentMethod="communication"></dlog_login>
		</el-dialog>
		<el-dialog title="" width="500px" :visible.sync="pasModify_dlog" :show-close="false" class="myDlog">
			<pas_modify v-on:parentMethod="communication"></pas_modify>
		</el-dialog>
	</div>
</template>

<script>
	import baseConst from '../assets/js/baseConst.js' //注意路
	const dlog_login = () =>
		import("@/components/homePage/login_1.vue"); //登录
	const pas_modify = () =>
		import("@/components/homePage/user/pas_modify.vue"); //更改密码
	export default {
		components: {
			dlog_login,
			pas_modify
		},
		provide() { //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。                                             
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				selectIndex: 0,
				dlog_login: false,
				pasModify_dlog: false, //修改密码
				isLogin: false,
				userObj: {},
				imgAPI: '',
				isRouterAlive: true //控制视图是否显示的变量
			}
		},
		created: function() {
			let _this = this;
			var sUserAgent = navigator.userAgent.toLowerCase();
			var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
			var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
			var bIsMidp = sUserAgent.match(/midp/i) == "midp";
			var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
			var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
			var bIsAndroid = sUserAgent.match(/android/i) == "android";
			var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
			var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
			if(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
				_this.$router.push('/mob');
			} else {
				_this.imgAPI = baseConst.IMG_API;
				let userObj = JSON.parse(localStorage.getItem('ind_user'));
				_this.userObj = userObj;
				if(userObj) {
					_this.isLogin = true;
				}
				if(_this.$route.query.type) {
					_this.selectIndex = parseInt(_this.$route.query.type);
				} else {
					_this.$router.push('/homePage');
				}
				//_this.$router.push('/mob');
			}

		},
		methods: {
			reload() {
				this.isRouterAlive = false; //先关闭，
				this.$nextTick(function() {
					this.isRouterAlive = true; //再打开
				})
			},
			/**  * -----登录注册
			 * @version 1.0  * @author 您的大名 2019年11月29日 */
			goLogin() {
				let _this = this;
				_this.dlog_login = true;
			},
			/**  * -----修改密码
			 * @version 1.0  * @author 您的大名 2019年11月29日 */
			open_pas_modify() {
				let _this = this;
				_this.pasModify_dlog = true;
			},
			/**  * -----退出登录
			 * @version 1.0  * @author 您的大名 2019年11月29日 */
			outLogin() {
				let _this = this;
				localStorage.removeItem('ind_user');
				localStorage.removeItem('ind_access_token')
				_this.$router.go(0);
			},
			handleCommand(command) {
				//this.$message('click on item ' + command);
				let _this = this;
				switch(command) {
					case '2':
						_this.outLogin();
						break;
					case '1':
						_this.goAdmin();
						break;
					case '3':
						_this.open_pas_modify();
						break;
					default:
				}
			},
			/**  * -----去往个人中心
			 * @version 1.0  * @author 您的大名 2019年11月29日 */
			goAdmin() {
				let _this = this;
				_this.$router.push('oUserAdmin_index');
			},

			/**  * -----这个组件的子组件通信处理    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			communication(type) {
				let _this = this;
				switch(type) {
					case 'login_success':
						_this.$router.go(0);
						break;
					case 'pas_modify':
						localStorage.removeItem('ind_user');
						localStorage.removeItem('ind_access_token');
						_this.$router.go(0);
						_this.dlog_login = true;
						break;
					default:
				}
			},
			/**  * -----去往其他栏目
			* @version 1.0  * @author 您的大名 2019年11月21日  
			* const FH =1;//概念孵化
			    const RC =2;//人才服务
			    const SS =3;//赛事展会
			    const SJ =4;//设计众包
			    const XW =5;//新闻资讯
			    const ZC =6;//政策法规* */
			openClassfy(type,clasType) {
				let _this = this;
				_this.selectIndex = type;
				_this.reload();
				if(type === 0) {
					_this.$router.push('/homePage');
				} else if(type === '设计成果') {
					_this.$router.push('/dsignCg');
				} else if(type === '专家资源' || type === '设计机构' || type === '设计师') {
					_this.$router.push({
						name: 'disgnZhuanjia',
						query: {
							type: type
						}
					});
				} else {
					_this.$router.push({
						name: 'newsList',
						query: {
							class_id: type,
							clasType:clasType
						}
					});

				}

				//				switch(type) {
				//					case 0:
				//						_this.$router.push('/homePage');
				//						break;
				//					case 1:
				//						_this.$router.push({
				//							name: 'conceptIncubation',
				//							query: {
				//								class_id: '1'
				//							}
				//						});
				//						break;
				//					case 2:
				//						_this.$router.push({
				//							name: 'talentService',
				//							query: {
				//								class_id: '2'
				//							}
				//						});
				//						break;
				//					case 3:
				//						_this.$router.push({
				//							name: 'eventExhibition',
				//							query: {
				//								class_id: '3'
				//							}
				//						});
				//						break;
				//					case 4:
				//						_this.$router.push({
				//							name: 'designCrowdsourcing',
				//							query: {
				//								class_id: '4'
				//							}
				//						});
				//						break;
				//					case 5:
				//						_this.$router.push({
				//							name: 'newsAndInformation',
				//							query: {
				//								class_id: '5'
				//							}
				//						});
				//						break;
				//					case 6:
				//						_this.$router.push({
				//							name: 'policiesAndRegulations',
				//							query: {
				//								class_id: '6'
				//							}
				//						});
				//						break;
				//				}
			},
		}
	}
</script>

<style scoped>
	.tempD {}
	
	.headD{ height: 95px; background-color: rgb(92, 93, 93); position: relative;}
	.logo{ width: 40px; height: 40px; position: absolute; top: 0; bottom: 0; margin: auto; left: 30px; background-image: url(../../public/icon/002.png); background-size: cover; background-repeat: no-repeat; background-position: center;}
	.logo_1{ width: 40px; height: 40px; position: absolute; top: 0; bottom: 0; margin: auto; left: 100px; background-image: url(../../public/icon/003.png); background-size: cover; background-repeat: no-repeat; background-position: center;}
	.shuline{ position: absolute; height: 30px; width: 1px; background-color: #ccc; left: 85px; top: 0; bottom: 0; margin: auto;}
	.websiteName{ height: 30px; line-height: 50px; position: absolute; top: 0; bottom: 0; margin: auto; left: 150px; color: #fff;}
	.websiteName img{ height: 100%;}
	.loginAregister{ height: 30px; line-height: 30px;
		/*position: absolute;*/
		top: 0; bottom: 0; margin: auto; right: 20px; color: #fff; background-color: rgb(236, 65, 77); font-size: 12px; padding: 0 10px; cursor: pointer;}
	.unnam{ height: 30px; line-height: 30px; color: #fff; top: 0; bottom: 0; margin: auto; right: 20px; color: #fff;
		/*background-color: rgb(236, 65, 77);*/
		font-size: 12px; padding: 0 10px; cursor: pointer; margin-left: 5px;}
	.unnam .el-dropdown{ color: #fff;}
	.classfyD{ width: 100%; height: 50px; align-items: center; display: flex; flex-direction: row; justify-content: space-around;/*background-color: rgb(57, 47, 45);*/
		color: #fff;}
	.classfyD .classfyD_item{ flex: 1; text-align: center; border-right: 1px solid rgb(92, 93, 93); cursor: pointer; font-size: 1rem;}
	.classfyD_item.active{ color: #9C98F4;color: #000;}
	.footerD{ background-color: rgb(62, 58, 57);}
	.logoAndName{ height: 60px; display: flex; flex-direction: row; padding: 10px; width: 90%; margin: auto; margin-bottom: 15px;}
	.footer_logo{ height: 60px; width: 60px; border-radius: 50%; background-color: #ccc;}
	.comname{ color: #ccc; display: flex; align-items: center; margin-left: 20px;}
	.clickMenu{ display: flex; flex-direction: row; width: 100%; margin: auto; padding-left: 13px; box-sizing: border-box;}
	.clickMenu .clickMenu_item{ color: #ccc; padding: 0 20px; border-right: 1px solid #ccc; cursor: pointer;}
	.banuqan, .beian{ width: 100%; margin: auto; color: #ccc; line-height: 30px; padding-left: 32px; box-sizing: border-box;}
	.uinfoD{ position: absolute; height: 40px; right: 20px; top: 0; bottom: 0; margin: auto; display: inline-flex;}
	.uphoto{ width: 40px; height: 40px; background-color: #fff; border-radius: 50%; overflow: hidden;}
	.uphoto img{ width: 100%;}
	.head_1{ height: 95px; background-color: #2C3E50; display: flex;flex-direction: row;opacity: 0.9;/*position: fixed;top: 0;z-index: 2;*/
		width: 100%;}
	.websiteTit{ line-height: 95px;}
	.websiteTit img{ width: 40px;vertical-align: middle;}
	.websiteTit img:first-child{ margin: 0 5px 0 10px;}
	.websiteTit img:nth-child(3){ margin: 0 5px 0 10px;}
	.websiteTit .wbame{ width: 15rem;}

</style>
<style type="text/css">
	.myDlog .el-dialog{ display: flex; flex-direction: column; margin: 0 !important; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); max-height: calc(100% - 30px); max-width: calc(100% - 30px); background-color: rgba(255, 255, 255, 0)!important; box-shadow: none;}
	.myDlog.el-dialog__wrapper{ overflow: hidden!important;}
	.myDlog .el-dialog .el-dialog__header{ padding: 0;}
	.myDlog .el-dialog .el-dialog__body{ flex: 1; overflow: auto; padding: 10px; border-radius: 10px; background-color: rgba(255, 255, 255, 0);}

</style>